




















import Vue from 'vue';
export default Vue.extend({
  name: 'SSIDCell',
  props: {
    ssidName: {
      type: String,
      required: true,
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SSIDCell.vue